{
  "cms.videoListing.field.title": "Title",
  "cms.videoListing.field.video": "Video",
  "cms.videoListing.field.url": "URL",
  "cms.videoListing.field.body": "Additional info (shown in the accordion)",
  "cms.videoListing.error.titleRequired": "Title is required (max 200 characters).",
  "cms.videoListing.error.titleNotDerivable": "The title must contain at least one Latin letter or number.",
  "cms.videoListing.error.videoUrlHttps": "Provide an https:// link or upload a video file."
}
